module.exports = __webpack_public_path__ + "img/formador-10.02d83af1.png";